import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './PriceLabel.module.scss';

export const PriceLabel = ({ knockout, className, children }: Props) => {

    const classes = classNames(styles.default, className, {
        [styles.knockout]: knockout
    });

    return <div className={classes}>{children}</div>;
};

type Props = PropsWithChildren<{
    className?: string;
    knockout?: boolean;
}>;